import {
  KeyboardEvent, memo, useEffect, useState,
} from 'react';

import Input from 'shared/components/Input';
import { ENTER_KEY } from 'shared/constants/common.constants';

import styles from './styles.module.scss';

interface Props {
  currentPage: number;
  onPageChange: (page: string) => void;
  totalPages: number;
}

const SelectPageInput = ({ onPageChange, currentPage, totalPages }: Props) => {
  const [value, setValue] = useState<string | number>(currentPage);

  const handleChange = (pageValue: string) => {
    setValue(pageValue);
  };

  const onPageSelect = () => {
    const pageValue = Number(value);
    if (pageValue === currentPage) return;
    if (pageValue <= totalPages && pageValue >= 1) {
      onPageChange(String(pageValue));
    } else {
      const defaultPage = 1;
      setValue(defaultPage);
      onPageChange(String(defaultPage));
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === ENTER_KEY) {
      onPageSelect();
    }
  };

  useEffect(() => {
    setValue(currentPage);
  }, [currentPage]);

  return (
    <Input
      onBlur={onPageSelect}
      className={styles.wrap}
      value={String(value)}
      handleChange={((inputData) => handleChange(inputData))}
      type="number"
      onKeyDown={handleKeyDown}
    />
  );
};

export default memo(SelectPageInput);
